import React from 'react'
import { connect } from 'react-redux'
import styles from './Auths.module.css';
import { getDateMDYY, getStatusIndicator } from '_helpers'

class PatientHomeAdmissionAuths extends React.Component {

    render() {
        let firstAuth;
        firstAuth = Object.keys(this.props.auths).length > 0 ? this.props.auths[Object.keys(this.props.auths)[0]].id : 0;
        return (
            <div>
                <div className={styles.auth_header}>Authorizations - {this.props.payer}</div>
                {Object.keys(this.props.auths).length === 0 &&
                    <i>No authorizations</i>
                }
                {Object.keys(this.props.auths)
                    .map(id => {
                        const auth = this.props.auths[id];
                        if (auth.id === firstAuth) {
                            return (
                                <div className={styles.auth_wrapper} key={auth.id}>
                                    <span className={styles.indicator}>{getStatusIndicator(auth.status)}</span>
                                    <span className={styles.date_range}>{getDateMDYY(auth.startDate) + ' - ' + getDateMDYY(auth.endDate)}</span>
                                    <span className={styles.visits}>{auth.visits + ' visits'}</span>
                                    <span className={styles.remaining}>
                                        {new Date(auth.endDate) >= new Date() &&
                                            <>
                                                ({auth.visitsRemaining} visits remaining)
                                            </>
                                        }
                                    </span>

                                </div>
                            )
                        } else {
                            return (
                                <div className={styles.auth_wrapper} key={auth.id}>
                                    <span className={styles.indicator}></span>
                                    <span className={styles.date_range}>{getDateMDYY(auth.startDate) + ' - ' + getDateMDYY(auth.endDate)}</span>
                                    <span className={styles.visits}>{auth.visits + ' visits'}</span>
                                    <span className={styles.remaining}></span>
                                </div>
                            )
                        }
                    })
                }

            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        payer: state.entities.insured[Object.keys(state.entities.insured)
            .find(i => state.entities.insured[i].epno === ownprops.epno && state.entities.insured[i].pyno === ownprops.pyno)].payerName,
        auths: Object.keys(state.entities.auths)
            .filter(key => { return state.entities.auths[key].epno === ownprops.epno && state.entities.auths[key].pyno === ownprops.pyno })
            .sort((a, b) => new Date(state.entities.auths[b].endDate).getTime() - new Date(state.entities.auths[a].endDate).getTime())
            .map(key => state.entities.auths[key]),
    };
}

const connectedPatientHomeAdmissionAuths = connect(mapStateToProps)(PatientHomeAdmissionAuths);
export { connectedPatientHomeAdmissionAuths as PatientHomeAdmissionAuths };

